import { Button, Image } from 'react-bootstrap'
import pmimage from "../../assets/images/600.jpg"
import PmSlider from "../PMKusumYojna/PmSlider";

const WhitePaper = () => {
  return (
    <>

      <section className="text-center my-4 px-3 ">

        <div className="col-lg-10 col-md-12 mx-auto text-center pt-4 pb-2">
          <h2 className="TextRes" style={{ position: 'relative', color: 'black' }}>
            <span
              style={{
                fontSize: '35px',
                position: 'absolute',
                top: '-15px',
                left: '50%',
                transform: 'translateX(-50%)',
                borderBottom: '2px solid #faab04',
                width: '50px',
              }}
            ></span>
            Download Our  {' '}
            <span style={{ color: '#a20000' }}>
              Technical Whitepaper
            </span>
          </h2>
        </div>


        <div className="my-2">
          <p style={{ fontSize: '18px', color: '#a20000', fontWeight: 'bold' }}>
            Ensuring Minimum CUF of 19% for a Solar Power Plant Over 25 Years: A Guide for Developers under PM-KUSUM Scheme
          </p>
        </div>

        {/* <div className="container">
          <div className="row align-items-center justify-content-center">
            <div className="col-lg-6 col-md-12 mb-4 mb-lg-0">
              <div className="image-container" style={{ width:'400px', boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px', borderRadius: '10px' }}>
                <Image src={pmimage} className="image" style={{ width: '100%', borderRadius: '10px' }} />
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <p style={{ fontWeight: '400', fontSize: '18px' }}>
                Discover actionable insights on selecting the right solar panels and strategies to ensure that your solar power plant achieves the minimum required CUF of 19% under the PM-KUSUM Yojana. This comprehensive guide provides essential information for farmers and developers to optimize their solar projects.
              </p>
              <div className="text-center my-2">
                <a href="/PM-KUSUM Whitepaper.pdf" download="PM-KUSUM Whitepaper.pdf">
                  <Button className="download-button" style={{ backgroundColor: '#a20000', color: '#ffffff' }}>
                    Download
                  </Button>
                </a>
              </div>
            </div>
          </div>
        </div> */}
        <div className="container py-5">
          <div className="row align-items-center justify-content-center">
            {/* --- Image Column --- */}
            <div className="col-lg-6 col-md-12 mb-4 mb-lg-0 d-flex justify-content-center">
              <div
                className="image-container"
                style={{
                  maxWidth: '450px',
                  boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
                  borderRadius: '12px', // Slightly larger border-radius
                  overflow: 'hidden', // Ensures image conforms to border-radius
                }}
              >

                <Image
                  src={pmimage}
                  className="img-fluid"
                  style={{ width: '100%', height: 'auto', display: 'block' }}
                />
              </div>
            </div>

            {/* --- Text and CTA Column --- */}
            <div className="col-lg-6 col-md-12">
              {/* Added a clear, impactful heading */}
              <h2 style={{ fontSize: '28px', fontWeight: '700', color: '#a20000', marginBottom: '15px' }}>
                Achieve 19% CUF: Your PM-KUSUM Success Guide
              </h2>

              {/* Revised, punchier description */}
              <p style={{ fontWeight: '400', fontSize: '18px', lineHeight: '1.6' }}>
                Maximize your solar project's performance under the **PM-KUSUM Yojana**. This comprehensive **White Paper** delivers **actionable insights** on panel selection and proven strategies to ensure your solar power plant achieves the mandated minimum **Capacity Utilization Factor (CUF) of 19%**. Essential reading for farmers and developers optimizing their investment.
              </p>

              <div className="mt-4">
                <a
                  href="/PM-KUSUM Whitepaper.pdf"
                  download="PM-KUSUM Whitepaper.pdf"
                  style={{ textDecoration: 'none' }} 
                >

                  <Button
                    className="download-button py-2 px-4" 
                    style={{
                      backgroundColor: '#a20000', 
                      color: '#ffffff',
                      fontSize: '18px', 
                      fontWeight: '600',
                      borderRadius: '8px',
                      border: 'none',
                      transition: 'background-color 0.3s', 
                    }}
                    onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#830000')}
                    onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#a20000')}
                  >
                    Download the Full White Paper
                  </Button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <PmSlider />
    </>
  )
}

export default WhitePaper